<template>
  <v-layout
    row
    wrap
    fill-height
    class="justify-center align-content-center error"
  >
    <v-card
      class="elevation-4 pa-4 text-xs-center"
      width="400"
    >
      <h1 class="error--text">
        ID INVALIDA
      </h1>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: 'NoIDCard'
}
</script>

<style scoped>

</style>
